/** XML decimals use a point and two places: 6.5 -> "6.50". */
export function xmlNumber(n: number): string {
  return (Math.round(n * 100) / 100).toFixed(2);
}

/**
 * German display uses a comma and one decimal place: 6.5 -> "6,5".
 * Every figure's point value is an exact multiple of 0.1 (checked against
 * all three catalogues), so one place loses no precision — and keeps
 * two-digit totals (e.g. "10,0") the same width as one-digit ones (e.g.
 * "9,5") in the fixed-width score column in the programme view.
 */
export function deNumber(n: number): string {
  return (Math.round(n * 10) / 10).toFixed(1).replace('.', ',');
}

/** Accept "6,5" as well as "6.5" from a text input. */
export function parseDeNumber(s: string): number {
  const n = Number.parseFloat(s.replace(',', '.'));
  return Number.isFinite(n) ? n : Number.NaN;
}

export function todayISO(): string {
  return new Date().toISOString().slice(0, 10);
}

/** A filename-safe fragment, e.g. "rsv-1910-langenselbold". */
export function slug(s: string, fallback = 'registration'): string {
  const out = s
    .toLowerCase()
    .replace(/[äöüß]/g, (c) => ({ ä: 'ae', ö: 'oe', ü: 'ue', ß: 'ss' })[c] ?? c)
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
    .slice(0, 40);
  return out.length > 0 ? out : fallback;
}
